/*@flow*/
import Tile from './Tile';
import Mapbox from './Mapbox';
import CartoTile from './CartoTile';
import CartoTile2 from './CartoTile2';
import Control from './Control';
import Zoom from './Zoom';
import Marker from './Marker';
import CircleMarker from './CircleMarker';
import Circle from './Circle';
import Polygon from './Polygon';
import GeoJSONUrl from './GeoJSONUrl';
import Draw from './Draw';
import Label from './Label';

const mapping = {
  vector: Mapbox,
  tile: Tile,
  cdb: CartoTile,
  cdb2: CartoTile2,
  control: Control,
  zoom: Zoom,
  marker: Marker,
  circlemarker: CircleMarker,
  circle: Circle,
  polygon: Polygon,
  geojsonURL: GeoJSONUrl,
  draw: Draw,
  label: Label,
};

export default function adapter(name: string): any | null {
  if (!(name in mapping)) {
    if (__DEV__) {
      throw new Error('[adapter] Unknown adapter `' + name + '`.');
    } else {
      return null;
    }
  }

  return mapping[name];
}
